module.exports = __webpack_public_path__ + "static/carbon-dracula-f5c0fe674ddad7ab8708616ed332149e.svg";